export default class Breach extends Phaser.Sprite {
    constructor(x, y) {
        super(game, x, y, "items", "breach.png");
        game.physics.arcade.enableBody(this);
        this.anchor.set(0.5, 0.5);
        this.body.immovable = true;
    }
    disable(obj) {
        game.sounder.play('pop-1');
        this.frameName = "breach_closed.png";
        const cropRect = new Phaser.Rectangle(0, 0, obj.width, obj.height * 0.7);
        obj.anchor.set(0.5, 1);
        obj.crop(cropRect);
        obj.x = this.x;
        obj.y = this.y + 5;
        obj.setDisabled();
        this.disabled = true;
        game.gameState.history.push({ id: 'breach', msg: `Patched the hull breach using ${obj.constructor.label}` });
    }
}


// WEBPACK FOOTER //
// ./src/objects/breach.js